import { useEffect, useRef } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState, realtyStore } from "../../../store";
import { UserActionCreator } from "../../../store/userActions";
import { connect } from "react-redux";
import { selectUserPending, selectUserToken } from "../../../store/selectors";
import { injectStore } from "../../../utils";
import {
  AUTH_LOGOUT_EVENT,
  isAuthLogoutStorageEvent,
} from "../../../utils/authSession";

const normalizeAuthToken = (value) => {
  const token = String(value || "").trim();
  return token && token !== "undefined" && token !== "null" ? token : "";
};

const PRIVATE_ROUTES = {
  test: "/lol",
  payment: "/payment",
  verifyEmail: "/profile/verify",
  aiSearch: "/ai-search",
  personalData: "/personal-data",
  clientBase: "/client-base",
  classifiedsMy: "/classifieds/my",
  classifiedsFavorites: "/classifieds/favorites",
  classifiedsModeration: "/classifieds/moderation",
};

const AUTH_ROUTES = {
  signIn: "/signin",
  signUp: "/signup",
  signInWithSlash: "/signin/",
  signUpWithSlash: "/signup/",
  resetPassword: "/reset-password",
};

export const _AuthHoc = ({
  pending,
  children,
  getUserInfo,
  logout,
  restoreSessionToken,
  token,
}) => {
  const [cookies, , removeCookie] = useCookies([
    "userToken",
    "rememberMe",
  ]);
  const params = useLocation();
  const navigate = useNavigate();
  const userToken = normalizeAuthToken(cookies.userToken);
  const storeToken = normalizeAuthToken(token);
  const url = params.pathname.toLowerCase();
  // const isPrivate =
  //   Object.values(PRIVATE_ROUTES).some((route) => url.startsWith(route)) ||
  //   url === "/" ||
  //   url === "";
  const isPrivate =
      Object.values(PRIVATE_ROUTES).some((route) => url.startsWith(route));
  const isAuthRoute = Object.values(AUTH_ROUTES).includes(
    params.pathname.toLowerCase(),
  );
  const isAuth = Boolean(userToken || storeToken);
  const initialSession = useRef({
    getUserInfo,
    restoreSessionToken,
    token: userToken,
  });

  useEffect(() => {
    injectStore(realtyStore);
  }, []);

  useEffect(() => {
    const handleLogout = () => {
      removeCookie("userToken", { path: "/" });
      removeCookie("rememberMe", { path: "/" });
      logout();
    };
    const handleStorage = (event: StorageEvent) => {
      if (isAuthLogoutStorageEvent(event)) handleLogout();
    };

    window.addEventListener(AUTH_LOGOUT_EVENT, handleLogout);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(AUTH_LOGOUT_EVENT, handleLogout);
      window.removeEventListener("storage", handleStorage);
    };
  }, [logout, removeCookie]);

  useEffect(() => {
    const session = initialSession.current;
    if (!session.token) return;

    session.restoreSessionToken(session.token);
    session.getUserInfo();
  }, []);

  useEffect(() => {
    if (!isAuth && isPrivate && !pending) {
      navigate(AUTH_ROUTES.signIn);
    }
    if (isAuth && isAuthRoute && !pending) {
      navigate("/");
    }
  }, [isAuth, isAuthRoute, isPrivate, navigate, pending]);

  return children;
};

const mapStateToProps = (state: RootState) => ({
  token: selectUserToken(state),
  pending: selectUserPending(state),
});

const mapDispatchToProps = {
  getUserInfo: UserActionCreator.getUserInfo,
  logout: UserActionCreator.logout,
  restoreSessionToken: UserActionCreator.restoreSessionToken,
};

export const AuthHoc = connect(mapStateToProps, mapDispatchToProps)(_AuthHoc);
